import createIcon from '../../createIcon';

/**
 * @component @name LocalMovies
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggM1Y1SDE2VjNIOFY1SDZWM0g0VjIxSDZWMTlIOFYyMUgxNlYxOUgxOFYyMUgyMFYzSDE4Wk04IDE3SDZWMTVIOFYxN1pNOCAxM0g2VjExSDhWMTNaTTggOUg2VjdIOFY5Wk0xOCAxN0gxNlYxNUgxOFYxN1pNMTggMTNIMTZWMTFIMThWMTNaTTE4IDlIMTZWN0gxOFY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalMovies = createIcon('LocalMovies', [
  [
    'path',
    {
      d: 'M18 3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18ZM8 17H6V15H8V17ZM8 13H6V11H8V13ZM8 9H6V7H8V9ZM18 17H16V15H18V17ZM18 13H16V11H18V13ZM18 9H16V7H18V9Z',
      key: 'hen466',
    },
  ],
]);

export default LocalMovies;
